import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import { BASE_URL } from "./Constants.js";
import { useNavigate } from 'react-router-dom';
import Footer from './Footer.js';

const Manage_User = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [user, setUser] = useState([]);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const [totalPages, setTotalPages] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: 'USER_NAME', direction: 'asc' }); // Sorting state
  const navigate = useNavigate();

  // Fetch user profile info
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const fetchProfile = async () => {
      try {
        const response = await fetch(`${BASE_URL}profile`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const data = await response.json();
        setUser(data.profile.is_uniform_access_given);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  // Fetch users without filters
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('authToken');

        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}users?page=${page}&pageSize=${pageSize}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch users');
        }

        const data = await response.json();
        if (data.status === true) {
          setUsers(data.users || []);
          setTotalPages(Math.ceil(data.users.length / pageSize)); // Calculate total pages based on users
        } else {
          setError('Error fetching users');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [page, pageSize]);

  // Filter users based on search query
  useEffect(() => {
    const filtered = users.filter(user =>
      (user.USER_NAME && user.USER_NAME.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (user.USER_ID && user.USER_ID.toLowerCase().includes(searchQuery.toLowerCase()))
    );
    setFilteredUsers(filtered);
    setTotalPages(Math.ceil(filtered.length / pageSize)); // Calculate total pages based on filtered users
  }, [searchQuery, users, pageSize]);

  // Handle search query change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setPage(1); // Reset to page 1 when search query changes
  };

  // Handle sort
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Sort the users
  const sortedUsers = [...filteredUsers].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === 'asc' ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });

  // Add user button handler
  const handleAddUser = () => {
    navigate('/add_user');
  };

  // Handle page changes
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  // Handle page size changes
  const handlePageSizeChange = (e) => {
    setPageSize(e.target.value);
    setPage(1); // Reset to page 1 when page size changes
  };

  // Loading and error states
  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  // Paginate filtered users before sorting
  const paginatedUsers = sortedUsers.slice((page - 1) * pageSize, page * pageSize);
  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };
  return (
    <div className='page-wrapper'>
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div className="page-container"
      style={{
        marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '300px' : '0',
        transition: 'margin-left 0.3s ease',
        
      }}>
      <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen}/>
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12"><div className="d-flex mb-3">
                <div className="col-lg-9"></div>  <div className="col-lg-3">
                  {/* Only show the add user button if the user is an admin */}
                  {user === 'Y' && (
                    <div className="d-flex justify-content-between align-items-center mb-3" style={{textAlign:'right'}}>
                      {/* <button className="btn btn-primary" onClick={handleAddUser}>
                        Add User
                      </button> */}

<button class="btn btn-primary" onClick={handleAddUser} >
  <i class="fas fa-user-plus"></i> Add User
</button>

                    </div>
                  )}</div></div>

                  {/* Search section */}
                  <div className="d-flex mb-3">
                  <div className="col-lg-2">
                  <select
                      value={pageSize}
                      onChange={handlePageSizeChange}
                      className="form-control ml-2"
                    >
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={15}>15</option>
                      <option value={20}>20</option>
                    </select>
                    </div><div className="col-lg-10">
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={handleSearchChange}
                      placeholder="Search "
                      className="form-control"
                    />
                  </div></div>

                  {/* Users table */}
                  <div className="table-responsive table--no-card m-b-30">
                  <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>
                            S/N
                            <span
                              onClick={() => handleSort('SN')}
                              style={{ cursor: 'pointer', marginLeft: '5px' }}
                            >
                              {sortConfig.key === 'SN' && sortConfig.direction === 'asc' ? '↑' : '↓'}
                            </span>
                          </th>
                          <th>
                            ID
                            <span
                              onClick={() => handleSort('USER_ID')}
                              style={{ cursor: 'pointer', marginLeft: '5px' }}
                            >
                              {sortConfig.key === 'USER_ID' && sortConfig.direction === 'asc' ? '↑' : '↓'}
                            </span>
                          </th>
                          <th>
                            Name
                            <span
                              onClick={() => handleSort('USER_NAME')}
                              style={{ cursor: 'pointer', marginLeft: '5px' }}
                            >
                              {sortConfig.key === 'USER_NAME' && sortConfig.direction === 'asc' ? '↑' : '↓'}
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(paginatedUsers) && paginatedUsers.length > 0 ? (
                          paginatedUsers.map((user, index) => (
                            <tr key={user.USER_ID}>
                              <td>{(page - 1) * pageSize + (index + 1)}</td> {/* Corrected to show S/N */}
                              <td>{user.USER_ID}</td>
                              <td>{user.USER_NAME}</td>
                            </tr>
                          ))
                        ) : (
                          <tr><td colSpan="3">No users found</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination section */}
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn btn-secondary"
                      onClick={() => handlePageChange(page - 1)}
                      disabled={page <= 1}
                    >
                      Previous
                    </button>
                    <span>Page {page} of {totalPages}</span>
                    <button
                      className="btn btn-secondary"
                      onClick={() => handlePageChange(page + 1)}
                      disabled={page >= totalPages}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Manage_User;
